import React from 'react';
import { Peer, Peers } from '../../../types/SignalR';
import ProducerFooter from '../../ProducerComponents/ProducerFooter/ProducerFooter';
import ProjectUserFooter from '../../ProjectUserComponents/ProjectUserFooter/ProjectUserFooter';

import './MainSectionFooter.scss';

type MainSectionFooterProps = {
  token?: string;
  isProducer: boolean;
  sendRequestControlCallback: () => void;
  sendTakeControlCallback: () => void;
  sendGiveControlCallback: () => void;
  getPeerInfoCallback: (peerId: string) => Peer | null;
  peerRequestingControl: Peer | null;
  connectedPeers: Peers;
};
const MainSectionFooter = (props: MainSectionFooterProps) => {
  if (props.isProducer) {
    return <ProducerFooter />;
  }

  return (
    <ProjectUserFooter
      sendRequestControlCallback={props.sendRequestControlCallback}
      sendTakeControlCallback={props.sendTakeControlCallback}
      sendGiveControlCallback={props.sendGiveControlCallback}
      peerRequestingControl={props.peerRequestingControl}
      getPeerInfoCallback={props.getPeerInfoCallback}
      token={props.token}
      connectedPeers={props.connectedPeers}
    />
  );
};

export default MainSectionFooter;
